import React, { useState } from "react";
import styled from "styled-components";
import { FormRow, FormRowLabel, FormTextbox, TitleStack, BlockButton, Form, FormRowMessage, Card } from "fiver-react-ui-components";
const StyledWrapper = styled.div``;
const StyledButton = styled.button`
  font-size: 0.75rem;
  padding: 0;
  margin-bottom: 1rem;
  color: ${props => props.theme.colorAccent};
`;

const ConfirmStep = ({
  translations,
  isSubmitting,
  onStepClicked,
  isStepValid,
  values,
  dirty,
  isNonUk,
  signupError
}) => {
  const defaultSignupFields = [{
    field: "email",
    label: "Email"
  }, {
    field: "firstName",
    label: "First Name"
  }, {
    field: "lastName",
    label: "Last Name"
  }, {
    field: "username",
    label: "Username"
  }, {
    field: "birthDate",
    label: "Birth Date"
  }, {
    field: "mobileNumber",
    label: "Telephone Number"
  }, {
    field: "enterAddress",
    label: "Full Address"
  }, {
    field: "street1",
    label: "Address Line 1"
  }, {
    field: "street2",
    label: "Address Line 2"
  }, {
    field: "city",
    label: "City / Town"
  }, {
    field: "county",
    label: "County / State"
  }];
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
    title: "Data preview",
    subtitle: "Please confirm the following information is correct"
  }), /*#__PURE__*/React.createElement(Form, null, defaultSignupFields.map(item => {
    return values[item.field] ? /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormRowLabel, null, item.label), /*#__PURE__*/React.createElement(FormTextbox, {
      style: {
        paddingLeft: "1rem"
      },
      value: values[item.field],
      isReadOnly: true
    })) : null;
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    margin: "0 0 1rem",
    isVisible: signupError !== undefined
  }, signupError), /*#__PURE__*/React.createElement(BlockButton, {
    type: "submit",
    isLoading: isSubmitting,
    disabled: !isStepValid || !dirty,
    style: {
      marginBottom: "1rem"
    }
  }, translations.finish), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(3)
  }, translations.edit)));
};

export default ConfirmStep;